import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const uploadProgramDocumentContent: (
  fetchContext: FetchContext,
  file: File,
  accessToken?: string,
) => Promise<string> = (fetchContext, file, accessToken) => {
  const formData = new FormData();
  formData.append('mediaUploadRequest', file);
  return fetch(
    `${fetchContext.baseUrl}/api/staff/program-documents/content`,
    {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    },
  ).then((response) => responseErrorHandler<string>(fetchContext.errorStore, response, 'upload program document content', !response.ok, [], true));
};
